export const stats = [
  { value: "50+", label: "Games Developed" },
  { value: "200K+", label: "Active Players" },
  { value: "300+", label: "Guild Members" },
  { value: "8+", label: "Years Experience" },
];

export const features = [
  {
    icon: "ri-gamepad-line",
    title: "Game Development",
    desc: "End-to-end game development from concept to launch across mobile, PC, and Web3 platforms.",
    accent: "#00ff88",
  },
  {
    icon: "ri-shield-star-line",
    title: "Guild Operations",
    desc: "Professional guild management systems powering elite gaming communities worldwide.",
    accent: "#f59e0b",
  },
  {
    icon: "ri-group-line",
    title: "Social Platforms",
    desc: "Custom-built social ecosystems connecting players, streamers, and gaming communities.",
    accent: "#00ff88",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Engineering",
    desc: "High-performance backend systems, APIs, and infrastructure for gaming at scale.",
    accent: "#f59e0b",
  },
];

export const testimonials = [
  {
    quote: "AWWAL transformed our guild from a casual group into a professional esports powerhouse. Their platform is unmatched.",
    author: "RavenX_Pro",
    role: "Guild Master, Shadow Legion",
    avatar: "https://public.readdy.ai/ai/img_res/3be90d5df917b73491a56d4a5976908a.jpg",
  },
  {
    quote: "The game they developed for us hit 100K downloads in the first month. Incredible team with deep technical expertise.",
    author: "Sarah Chen",
    role: "CEO, NexGen Studios",
    avatar: "https://readdy.ai/api/search-image?query=professional%20woman%20executive%20portrait%20dark%20background%20studio%20lighting%20confident%20smile%20asian%20female%20business&width=80&height=80&seq=t2&orientation=squarish",
  },
  {
    quote: "Their social platform integration tripled our community engagement. Best decision we made for our gaming brand.",
    author: "DarkStar_99",
    role: "Founder, Apex Community",
    avatar: "https://readdy.ai/api/search-image?query=young%20male%20gamer%20streamer%20portrait%20dark%20room%20RGB%20lighting%20gaming%20setup%20content%20creator&width=80&height=80&seq=t3&orientation=squarish",
  },
];
